// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { PFixFieldSet } from '../Fields/FieldsImport.js'
import { FieldsFactory } from '../Factory/FieldsFactory.js'
import { EntitlmentDocument } from '../../../../Utils/Entitlment/EntitlmentDocument.js'

var EntitlementDocumentGroup = function (pfixFieldSet)
{
    PFixFieldSet.call(this, FieldsFactory.DOCUMENT_GROUP, null, pfixFieldSet)
}

EntitlementDocumentGroup.prototype = Object.create(PFixFieldSet.prototype)

EntitlementDocumentGroup.CreateDocument = function (documentId, name, content)
{
    let gr = new EntitlementDocumentGroup();
    gr.setId(documentId);
    gr.setName(name);
    gr.setContent(content);

    return gr;
}

EntitlementDocumentGroup.prototype.GetDoucument = function ()
{
    return new EntitlmentDocument(this.getId(), this.getName(), this.getContent());
}

EntitlementDocumentGroup.prototype.getId = function ()
{
    return this.GetValue(FieldsFactory.FIELD_DOCUMENT_ID);
}

EntitlementDocumentGroup.prototype.setId = function (value)
{
    this.SetField(FieldsFactory.FIELD_DOCUMENT_ID, value);
}

EntitlementDocumentGroup.prototype.getName = function ()
{
    return this.GetValue(FieldsFactory.FIELD_NAME);
}

EntitlementDocumentGroup.prototype.setName = function (value)
{
    this.SetField(FieldsFactory.FIELD_NAME, value);
}

EntitlementDocumentGroup.prototype.getContent = function ()
{
    return this.GetValue(FieldsFactory.FIELD_DOCUMENT_CONTENT);
}

EntitlementDocumentGroup.prototype.setContent = function (value)
{
    this.SetField(FieldsFactory.FIELD_DOCUMENT_CONTENT, value);
}

export { EntitlementDocumentGroup }